var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-unit"},[_c('img',{style:({ width: `${_vm.iconWidth}px`}),attrs:{"src":_vm.iconURL}}),_c('p',{staticClass:"icon-unit-value"},[_vm._v(_vm._s(_vm.placeholderText(_vm.value)))]),_c('p',{staticClass:"icon-unit-unit"},[_vm._v(_vm._s(_vm.unit))])])
}
var staticRenderFns = []

export { render, staticRenderFns }